<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{sidebarHeader}}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new pt-4 pb-6" :settings="settings" id="dialogueTaskDetails">

      <div class="pl-6 pr-6 pb-6">
        <div v-if="this.$siteTypeId() != 1">
          <div class="pb-1">
            <label>Task Classification</label>
            <v-select class="mb-3" ref="taskClassificationTypeDropdown" placeholder="Search / Select Task Classification"  :options="taskClassificationTypeList" v-model="taskClassificationTypeDropdown"></v-select>
          </div>
        </div>

        <div>
          <label ref="nameLabel">Name</label>
          <vs-input autocomplete="off" class="w-full pb-2" v-model="formData.name"/>
        </div>

        <div class="pt-2">
          <label>Scene</label>
          <vs-select placeholder="Search / Select Scene" class="w-full pb-2" vs-multiple autocomplete v-model="formData.sceneId">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in scenes" />
          </vs-select>
        </div>

        <div class="pt-2">
          <label>Character</label>
          <vs-select placeholder="Search / Select Character" class="w-full pb-2" vs-multiple autocomplete v-model="formData.characterLookId">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in characters" />
          </vs-select>
        </div>

        <div class="pt-2">
          <label>Position</label>
          <ul class="demo-alignment">
            <li>
              <vs-radio v-model="formData.position" vs-value="1">Left</vs-radio>
            </li>
            <li>
              <vs-radio v-model="formData.position" vs-value="3">None</vs-radio>
            </li>
            <li>
              <vs-radio v-model="formData.position" vs-value="2">Right</vs-radio>
            </li>
          </ul>
        </div>

        <div class="pt-4 pb-2">
          <label>Text</label>
          <vs-textarea name="Text" counter="256" :counter-danger.sync="counterDanger" v-model="formData.text" class="w-full" />
        </div>

        <vs-divider></vs-divider>
        <div class="pt-2">
          <label>Speech</label>
          <ul class="flex flex-wrap items-center justify-center pt-2 pb-2">
            <li>
              <p-radio class="p-round p-fill p-smooth" color="success" v-model="formData.isTextToSpeech" :value="true" name="radio-tts">Text-To-Speech</p-radio>
            </li>
            <li>
              <p-radio class="p-round p-fill p-smooth" color="success" v-model="formData.isTextToSpeech" :value="false" name="radio-custom">Custom</p-radio>
            </li>
          </ul>
          <div v-show="!formData.isTextToSpeech">
            <file-pond
              v-show="newFileSelected"
              id="filepond"
              ref="pond"
              :server="uploadLocation"
              label-idle="Drop audio file here or <span class='filepond--label-action'>Browse</span>"
              accepted-file-types="audio/*"
              :allow-multiple="false"
              allowPaste=false
              :instant-upload="true"
              :allow-image-preview="true"
              @processfile="uploadComplete"
              @removefile="fileRemoved"
            />
            <div v-if="formData.audioUrl && !newFileSelected" class="vx-row" style="justify-content: space-between;">
              <div class="vx-col" style="align-self: center;">
                <p><strong>Attached Audio</strong></p>
              </div>
              <div class="vx-col">
                <vs-button size="small" color="danger" type="flat" icon-pack="feather" icon="icon-x" @click="newFileSelected = true;formData.audioUrl = ''"/>
              </div>
            </div>
          </div>
          <div v-if="formData.isTextToSpeech" style="text-align: -webkit-center;text-align: -moz-center;">
            <vs-button :disabled="!formData.text" ref="preview" color="#c72a75" gradient-color-secondary="#5252e8" type="gradient" class="vs-con-loading__container" size="large" icon="settings_voice" @click="previewTts">Create & Preview</vs-button>
            <div v-if="(formData.audioUrl && talkifyAudioCreated) || formData.audioUrl" class="vx-row mt-2" style="justify-content: space-between;">
              <div class="vx-col" style="align-self: center;">
                <p><strong>{{ formData.audioUrl.substring(formData.audioUrl.indexOf('_') + 1) }}</strong></p>
              </div>
              <div class="vx-col">
                <vs-button size="small" color="danger" type="flat" icon-pack="feather" icon="icon-x" @click="formData.audioUrl = ''"/>
              </div>
            </div>
          </div>
        </div>
        <vs-divider></vs-divider>

        <div class="pb-1" style="display: inline-grid;">
          <label>Task Number</label>
          <vs-input-number class="numberinput" onClick="this.select();" v-model="formData.number" min="0" />
        </div>
        <div v-if="this.$siteTypeId() != 1">
          <vs-divider>Outcomes</vs-divider>

          
          
          <div class="pb-1">
            <label>Assessment Criteria</label>
            <v-select class="mb-2" ref="assessmentCriteriaDropdown" placeholder="Search / Select Assessment Criteria"  :options="assessmentCriteriaList" v-model="assessmentCriteriaDropdown"></v-select>
          </div>

          <div class="pb-1">
            <label>Essential Embedded Knowledge</label>
            <v-select class="mb-2" ref="eekDropdown" placeholder="Search / Select EEK"  :options="eekList" v-model="eekDropdown"></v-select>
          </div>

          <div class="pb-1">
            <label>Unit Standard</label>
            <v-select class="mb-2" ref="unitStandardDropdown" placeholder="Search / Select Unit Standard"  :options="unitStandardList" v-model="unitStandardDropdown"></v-select>
          </div>

          <div class="pb-1">
            <label>Spesific Outcome</label>
            <v-select class="mb-2" ref="spesificOutcomeDropdown" placeholder="Search / Select Spesific Outcome"  :options="spesificOutcomeList" v-model="spesificOutcomeDropdown"></v-select>
          </div>
          
        </div>
        <vs-divider>Go To</vs-divider>

        <div class="pt-1">
          <vs-radio v-model="gotoRadio" vs-value="existingTask">Existing Task</vs-radio>
        </div>
        <div class="pt-2">
          <vs-radio v-model="gotoRadio" vs-value="newTask">Create New Task</vs-radio>
        </div>
        <div class="pt-2">
          <vs-radio v-model="gotoRadio" vs-value="multipleTasks">Multiple Tasks</vs-radio>
        </div>
        <div class="pt-2">
          <vs-radio v-model="gotoRadio" vs-value="none">None</vs-radio>
        </div>

        <div class="pt-4" v-show="gotoRadio == 'existingTask'">
          <label>Go To</label>
          <vs-select placeholder="Search / Select Go To task" class="w-full pb-3" vs-multiple autocomplete v-model="formData.goTo">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in gotoList" />
          </vs-select>
          <div>
            <div style="margin-bottom: 8px; margin-top: 2px;">
              <vs-checkbox color="success" v-model="formData.useCoins">Coins</vs-checkbox>
            </div>
            <div v-if="formData.useCoins && gotoRadio == 'existingTask'">
              <div style="display: flex; margin-bottom: 8px; margin-left: 4px;">
                <vs-switch color="success" v-model="formData.isCoinsRecurring">
                  <span slot="on">Recurring</span>
                  <span slot="off">Once Only</span>
                </vs-switch>
                <vs-switch style="margin-left: 10px;" color="success" v-model="formData.addCoins">
                  <span slot="on">Add</span>
                  <span slot="off">Deduct</span>
                </vs-switch>
              </div>
              <label style="margin-left: 5px;">Coin Value</label>
              <vs-input autocomplete="off" v-validate="'numeric'" onClick="this.select();" name="Coin Value" style="margin-bottom: 5px; margin-left: 5px; width: 150px;" v-model="formData.coinValue" />
              <span style="margin-left: 5px;" class="text-danger text-sm" v-show="errors.has('Coin Value')">{{ errors.first('Coin Value') }}</span>
            </div>
          </div>
        </div>

        <div class="pt-4" v-show="gotoRadio == 'newTask'">
          <label>Task Type</label>
          <vs-select placeholder="Search / Select a Task Type" class="w-full pb-3" vs-multiple autocomplete v-model="formData.taskTypeId">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in taskTypeList" />
          </vs-select>
          <div>
            <div style="margin-bottom: 8px; margin-top: 2px;">
              <vs-checkbox color="success" v-model="formData.useCoins">Coins</vs-checkbox>
            </div>
            <div v-if="formData.useCoins && gotoRadio == 'newTask'">
              <div style="display: flex; margin-bottom: 8px; margin-left: 4px;">
                <vs-switch color="success" v-model="formData.isCoinsRecurring">
                  <span slot="on">Recurring</span>
                  <span slot="off">Once Only</span>
                </vs-switch>
                <vs-switch style="margin-left: 10px;" color="success" v-model="formData.addCoins">
                  <span slot="on">Add</span>
                  <span slot="off">Deduct</span>
                </vs-switch>
              </div>
              <label style="margin-left: 5px;">Coin Value</label>
              <vs-input autocomplete="off" v-validate="'numeric'" onClick="this.select();" name="Coin Value" style="margin-bottom: 5px; margin-left: 5px; width: 150px;" v-model="formData.coinValue" />
              <span style="margin-left: 5px;" class="text-danger text-sm" v-show="errors.has('Coin Value')">{{ errors.first('Coin Value') }}</span>
            </div>
          </div>
        </div>

        <div class="pt-4" v-show="gotoRadio == 'multipleTasks'">
          <vs-divider>Options</vs-divider>
          <div class="pt-2 pb-4">
            <ul>
              <li v-for="(option, index) in formData.options" :key="index">
                <vx-card style="margin-bottom: 15px;">
                  <div>
                    <label class="pt-2 float-left">Go To</label>
                    <vs-button id="remove-option-button" radius size="small" type="border" color="danger" icon-pack="feather" icon="icon-x" @click="deleteRow(index)"></vs-button>
                  </div>
                  <vs-select class="w-full pb-4" vs-multiple autocomplete v-model="option.nextTaskId">
                    <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in gotoList" />
                  </vs-select>
                  <div>
                    <div style="margin-bottom: 8px; margin-top: 2px;">
                      <vs-checkbox color="success" v-model="option.useCoins">Coins</vs-checkbox>
                    </div>
                    <div v-if="option.useCoins && gotoRadio == 'multipleTasks'">
                      <div style="display: flex; margin-bottom: 8px; margin-left: 4px;">
                        <vs-switch color="success" v-model="option.isCoinsRecurring">
                          <span slot="on">Recurring</span>
                          <span slot="off">Once Only</span>
                        </vs-switch>
                        <vs-switch style="margin-left: 10px;" color="success" v-model="option.addCoins">
                          <span slot="on">Add</span>
                          <span slot="off">Deduct</span>
                        </vs-switch>
                      </div>
                      <label style="margin-left: 5px;">Coin Value</label>
                      <vs-input autocomplete="off" v-validate="'numeric'" onClick="this.select();" name="Coin Value" style="margin-bottom: 5px; margin-left: 5px; width: 150px;" v-model="option.coinValue" />
                      <span class="text-danger text-sm" v-show="errors.has('Coin Value')">{{ errors.first('Coin Value') }}</span>
                    </div>
                  </div>
                  <div class="mt-4">
                    <label>Text</label>
                    <vs-textarea name="Text" class="w-full" v-model="option.text" style="border: 1px solid #c2c6dc" />
                  </div>
                </vx-card>
              </li>
            </ul>
          </div>
          <div>
            <vs-button ref="optionsAdd" class="w-full cursor-pointer" type="border" color="success" icon-pack="feather" icon="icon-plus" @click="addOptions"></vs-button><!-- v-scroll-to="'#charlook'" -->
          </div>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center pb-4 pt-1" slot="footer">
      <vs-button class="mr-4 vs-con-loading__container cursor-pointer" color="success" @click="addEditDialog" :disabled="isDisabled" ref="addupdateButton">{{buttoncaption}}</vs-button>
      <vs-button color="danger" class="mr-4 vs-con-loading__container cursor-pointer" @click="deleteApproach" v-show="formData.id" ref="deleteButton">Delete</vs-button>
      <vs-button type="border" class="ml-4 cursor-pointer" color="warning" @click="closeSidebar">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vueFilePond from 'vue-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import vSelect from 'vue-select'
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    moduleId: {
      type: String,
      required: true
    },
    courseId: {
      type: String,
      required: true
    },
    nodeSelected: {
      type: Object,
      required: false
    },
    taskClassificationTypes: {
      type: Array,
      required: false
    },
    buttoncaption: {
      type: String,
      required: false
    },
    sidebarHeader: {
      type: String,
      required: false
    },
    gotoList: {
      type: Array,
      required: false
    },
    sourceTaskId: {
      type: Number,
      required: false
    },
    taskTypeList: {
      type: Array,
      required: false
    }
  },

  data() {
    return {
      backgroundLoading:'#fff',
      formData: {
        id: 0,
        name: "",
        sceneId: 0,
        characterLookId: 0,
        text: "",
        position: "",
        goTo: 0,
        options: [],
        moduleId: "",
        courseId: "",
        sourceTaskId: 0,
        taskTypeId: 0,
        hasLogs: false,
        useCoins: false,
        isCoinsRecurring: false,
        addCoins: true,
        coinValue: "",
        number: 0,
        audioUrl: "",
        isTextToSpeech: false,
        unitStandardId: 0,
        spesificOutcomeId: 0,
        assessmentCriteriaId: 0,
        eekId: 0,
        taskClassificationTypeId: null,      
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      spesificOutcomeDropdown: null,
      unitStandardDropdown: null,
      assessmentCriteriaDropdown: null,
      eekDropdown: null,
      taskClassificationTypeDropdown: null,
      characters: [],
      scenes: [],
      gotoRadio: "none",
      counterDanger: false,
      newFileSelected: false,
      talkifyAudioCreated: false,
      talkifyPlaying: false,
      talkifyPlayer: null,
      spesificOutcomeList: [],
      unitStandardList: [],
      assessmentCriteriaList: [],
      eekList: [],
      taskClassificationTypeList: [],
      taskClassificationTypeText: null,
    };
  },
  components: {
    VuePerfectScrollbar,
    FilePond,
    'v-select': vSelect
  },
  computed: {
    isDisabled: function() {
      // return !(this.formData.sceneId && this.formData.characterLookId && (!this.formData.isTextToSpeech || this.talkifyAudioCreated) && this.formData.audioUrl);

      if (!this.formData.sceneId) {
        return true;
      }

      if (!this.formData.characterLookId) {
        return true;
      }

      if (!this.formData.audioUrl) {
        return true;
      }

      if (this.formData.isTextToSpeech && !this.talkifyAudioCreated) {
        return true;
      }

      return false;
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          this.initValues();
        }
      }
    },
    uploadLocation: {
      get() {
        return this.$buildUrl("tempupload");
      }
    },
  },
  watch: {
    isSidebarActive: function(val) {
      var self = this;
      if(val){
        this.gotoRadio = "none";

        var goToDisplayValue = 0;
        if(self.nodeSelected.dialogTask)
          goToDisplayValue = self.nodeSelected.dialogTask.goTo;
        else
          goToDisplayValue = 0;

        var onSceneSuccess = response => { self.scenes = response.data; };
        var onCharSuccess = response => { self.characters = response.data.map(function(item) {return {value: item.id, text: item.name, voiceTempo: item.voiceTempo, voiceName: item.voiceName }}); };

        self.$ajaxGet(self, "scene/GetSelectList", onSceneSuccess);
        self.$ajaxGet(self, "character/GetSelectList", onCharSuccess);

        self.formData.moduleId = self.moduleId;
        self.formData.courseId = self.courseId;

        self.taskClassificationTypeList = self.taskClassificationTypes;

        self.getEEK();
        self.getUnitStandard();
        self.getSpesificOutcome();
        self.GetAssessmentCriteria();
        
        if(self.nodeSelected.id){
          self.formData.id = self.nodeSelected.id;
          self.formData.name = self.nodeSelected.name;
          self.formData.sourceTaskId = self.sourceTaskId;
          self.formData.text = self.nodeSelected.dialogTask.text;
          self.formData.position = self.nodeSelected.dialogTask.position;
          self.formData.sceneId = self.zeroIfEmpty(self.nodeSelected.dialogTask.sceneId);
          self.formData.characterLookId = self.zeroIfEmpty(self.nodeSelected.dialogTask.characterLookId);
          self.formData.hasLogs = self.nodeSelected.dialogTask.hasLogs;
          self.formData.useCoins = self.nodeSelected.dialogTask.coinValue ? true : false;
          self.formData.addCoins = self.nodeSelected.dialogTask.coinValue > 0 ? true : false;
          self.formData.isCoinsRecurring = self.nodeSelected.dialogTask.isCoinsRecurring;
          self.formData.coinValue = self.nodeSelected.dialogTask.coinValue > 0 ? self.nodeSelected.dialogTask.coinValue : (self.nodeSelected.dialogTask.coinValue * -1);
          self.formData.audioUrl = self.nodeSelected.dialogTask.audioUrl;
          self.formData.isTextToSpeech = self.nodeSelected.dialogTask.isTextToSpeech;         

          self.taskClassificationTypeDropdown = self.taskClassificationTypeList.filter(function(item){
            return item.value == self.nodeSelected.taskClassificationTypeId;
          })[0];

          if (self.formData.isTextToSpeech && self.formData.audioUrl) {
            self.talkifyAudioCreated = true;
          }

          if (!self.formData.audioUrl) {
            self.newFileSelected = true;
          }
          
          if (self.nodeSelected.number)
            self.formData.number = self.nodeSelected.number;
          else
            self.formData.number = 0;

          if(goToDisplayValue != 0)
            self.formData.goTo = self.gotoList.filter(function(item){ return item.text.split(" ")[0] == goToDisplayValue; })[0].value;

          if(self.formData.goTo){
            self.gotoRadio = "existingTask";
          } else if (self.nodeSelected.dialogTask.options && self.nodeSelected.dialogTask.options.length > 0){
            self.gotoRadio = "multipleTasks";
            self.formData.options = self.nodeSelected.dialogTask.options;
          } else {
            self.gotoRadio = "none";
          }

        }else{
          this.initValues(self.sourceTaskId || 0);
        }
      }else {
        self.$refs.pond.removeFiles();
        var scrollOptions = {
          container: '#dialogueTaskDetails',
          easing: 'ease-in',
          offset: -10000,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(this.$refs["nameLabel"], 0, scrollOptions);
      }
    },
  },
  methods: {
    getEEK(){
      var self =this;

      var onSuccess = function (response) {
        self.eekList = response.data.map(function(item) {return {value: item.value,label: item.text}});
        if(self.nodeSelected.id){
          self.essentialEmbeddedKnowledgeDropdown = self.eekList.filter(function(item){return item.value == self.nodeSelected.essentialEmbeddedKnowledgeId})[0];
        }
      }

      self.$ajaxGet(self, "Course/EEK?courseId=" + self.courseId, onSuccess);
    },
    getUnitStandard(){
      var self =this;

      var onSuccess = function (response) {
        self.unitStandardList = response.data.map(function(item) {return {value: item.value,label: item.text}});
         if(self.nodeSelected.id){
          self.unitStandardDropdown = self.unitStandardList.filter(function(item){return item.value == self.nodeSelected.unitStandardId})[0];
        }
      }

      self.$ajaxGet(self, "Course/UnitStandard?courseId=" + self.courseId, onSuccess);
    },
    getSpesificOutcome(){
      var self =this;

      var onSuccess = function (response) {
        self.spesificOutcomeList = response.data.map(function(item) {return {value: item.value,label: item.text}});
        if(self.nodeSelected.id){
          self.spesificOutcomeDropdown = self.spesificOutcomeList.filter(function(item){return item.value == self.nodeSelected.spesificOutcomeId})[0];
        }
      }

      self.$ajaxGet(self, "Course/SpecificOutcome?courseId=" + self.courseId, onSuccess);
    },
    GetAssessmentCriteria(){
      var self =this;

      var onSuccess = function (response) {     
        self.assessmentCriteriaList = response.data.map(function(item) {return {value: item.value,label: item.text}});
        if(self.nodeSelected.id){
          self.assessmentCriteriaDropdown = self.assessmentCriteriaList.filter(function(item){return item.value == self.nodeSelected.assessmentCriteriaId})[0];
        }
      }

      self.$ajaxGet(self, "Course/AssesmentCriteria?courseId=" + self.courseId, onSuccess);
    },

    closeSidebar() {
      var self = this;
      if (self.talkifyPlaying) {
        self.talkifyPlaying = false;
        self.talkifyPlayer.pause();
        self.$vs.loading.close(self.$refs.preview.$el);
      }
      self.isSidebarActiveLocal = false;
    },
    addOptions() {
      this.formData.options.push({
        id: 0,
        taskId: this.formData.id,
        goTo: '',
        text: ''
      });
      var scrollOptions = {
        container: '#dialogueTaskDetails',
        easing: 'ease-in',
        offset: 1000000,
        force: true,
        cancelable: true,
        x: false,
        y: true
      }
      var cancelScroll = this.$scrollTo(this.$refs["optionsAdd"], 500, scrollOptions);
    },
    deleteRow(index) {
      this.formData.options.splice(index,1)
    },
    initValues(val) {
      this.formData.id = 0;
      this.formData.name = "";
      this.formData.sourceTaskId = 0;
      if(val){
        this.formData.sourceTaskId = val;
      }
      
      this.formData.text = "";
      this.formData.position = "3";
      this.formData.sceneId = "";
      this.formData.characterLookId = "";
      this.formData.goTo = "";
      this.gotoRadio = "none";
      this.formData.options = [];
      this.formData.taskTypeId = "";
      this.formData.useCoins = false;
      this.formData.addCoins = true;
      this.formData.isCoinsRecurring = false;
      this.formData.coinValue = "";
      this.formData.number = 0;
      this.formData.isTextToSpeech = false;
      this.newFileSelected = true;
      this.talkifyAudioCreated = false;
      this.talkifyPlaying = false;
      this.errors.clear();
      this.$refs.pond.removeFiles();
      this.spesificOutcomeDropdown = null;
      this.unitStandardDropdown = null;
      this.assessmentCriteriaDropdown = null;
      this.essentialEmbeddedKnowledgeDropdown = null;
      this.taskClassificationTypeDropdown = null;
    },
    saveData(val,taskTypeId){
      this.$emit('saveData',val,taskTypeId);
      this.$vs.loading.close(this.$refs.addupdateButton.$el);
      this.initValues(val);
    },
    addEditDialog() {
      var self = this;
      this.$validator.validateAll().then(result => {       
      if (result) {
        self.showLoadingOnButton();

        var onSuccess = response => {
          if(self.gotoRadio == "newTask"){
            self.saveData( response.data, self.formData.taskTypeId );
          }
          else {
            self.saveData(0, self.formData.taskTypeId);
            self.$vs.notify({
              title:'Information',
              color: "success",
              text: "Task Saved",
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-save'
            });
          }
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.addupdateButton.$el);
        };

        if(self.gotoRadio == "none" || self.gotoRadio == "newTask"){
          self.formData.options = [];
          self.formData.goTo = "0";
        } else if (self.gotoRadio == "multipleTasks"){
          self.formData.goTo = "0";
        } else if (self.gotoRadio == "existingTask"){
          self.formData.options = [];
        }

        if (self.talkifyPlaying) {
          self.talkifyPlaying = false;
          self.talkifyPlayer.pause();
          self.$vs.loading.close(self.$refs.preview.$el);
        }

        self.formData.unitStandardId = self.unitStandardDropdown ? self.unitStandardDropdown.value: null

        self.formData.essentialEmbeddedKnowledgeId = self.essentialEmbeddedKnowledgeDropdown ? self.essentialEmbeddedKnowledgeDropdown.value: null;

        self.formData.assessmentCriteriaId = self.assessmentCriteriaDropdown ?  self.assessmentCriteriaDropdown.value: null;

        self.formData.spesificOutcomeId = self.spesificOutcomeDropdown ?  self.spesificOutcomeDropdown.value: null;

        self.formData.taskClassificationTypeId = self.taskClassificationTypeDropdown ? self.taskClassificationTypeDropdown.value: null;

        self.$ajaxPost(self, "dialogtask/addeditdialogtask", self.formData, onSuccess, onFinally);
      }
      });
      var scrollOptions = {
        container: '#dialogueTaskDetails',
        easing: 'ease-in',
        offset: -1000,
        force: true,
        cancelable: true,
        x: false,
        y: true
      }
      var cancelScroll = this.$scrollTo(this.$refs["nameLabel"], 500, scrollOptions);
    },
    deleteTask() {
      var self = this;
      self.showLoadingOnDeleteButton();
      if(self.formData.hasLogs)
        self.showLoadingOnCytoscape();

      var onSuccess = response => {
        self.saveData();
        self.initValues();
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Task Deleted",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-trash'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.deleteButton.$el);
        self.$vs.loading.close(self.$parent.$el);
      };

      self.$ajaxDelete(self, "dialogtask/deletedialogtask/" + self.formData.id, onSuccess, onFinally);
    },
    showLoadingOnButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.addupdateButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnDeleteButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.deleteButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnCytoscape(){
      var self = this;
      self.$vs.loading({
        type: "corners",
        container: self.$parent.$el,
        scale: 1
      });
    },
    deleteApproach() {
      if(this.formData.hasLogs)
        this.openConfirm();
      else
        this.deleteTask();
    },
    openConfirm() {
      this.$emit("closeSidebar");
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Attention`,
        text: 'Are you sure you want to delete the selected dialog task?',
        accept: this.deleteTask,
        acceptText: "Yes, delete",
        cancelText: "No, cancel"
      })
    },
    uploadComplete(error, file) {
      var response = JSON.parse(file.serverId);
      if(response.url)
        this.formData.audioUrl = response.url;
    },
    fileRemoved(error, file) {
      this.formData.audioUrl = "";
    },
    previewTts() {
      var self = this;

      if (self.talkifyPlaying) {
        self.talkifyPlaying = false;
        self.talkifyPlayer.pause();
        self.$vs.loading.close(self.$refs.preview.$el);
        return;
      }

      self.talkifyAudioCreated = false;

      talkify.config = {
        remoteService: {
          host : 'https://talkify.net',
          speechBaseUrl: "/api/speech/v1",
          apiKey : '7dbb03ab-f8a5-4745-813b-1e644c70b00b',//'661fbcb8-e65f-42b3-aeab-3cd3edfefcbc',
          active: true //True to use Talkifys language engine and hosted voices. False only works for Html5Player.
        },
        ui:
        {
          audioControls: { //If enabled, replaces the built in audio controls. Especially good for the Web Speech API bits
            enabled: false
          }
        }
      }
      self.talkifyPlayer = new talkify.TtsPlayer();
      talkify.messageHub.subscribe("Stop Animation", "*.player.tts.pause", function(){
        self.talkifyPlaying = false;
        self.$vs.loading.close(self.$refs.preview.$el);
      });

      var charLookData = self.characters.filter(function(item) {return item.value == self.formData.characterLookId})[0];
      var voice = charLookData.voiceName;
      var tempo = charLookData.voiceTempo - 5;

      self.talkifyPlayer.forceVoice({name: voice})
      self.talkifyPlayer.setRate(tempo); // from -5 to 5
      self.talkifyPlayer.playText(self.formData.text);
      if(self.talkifyPlayer.isPlaying) {
        self.talkifyPlaying = true;
        self.$vs.loading({
          background: '#c72a75',
          type: "sound",
          color: "#fff",
          container: self.$refs.preview.$el,
          scale: 0.45
        });
      }

      self.$http({
        method: 'get',
        url: `https://talkify.net/api/speech/v1?texttype=text&text=${self.formData.text}&fallbackLanguage=-1&voice=${voice}&rate=${tempo}&key=${talkify.config.remoteService.apiKey}&whisper=false&soft=false&wordbreakms=0&volume=0&format=mp3`,
        responseType: 'blob'
      }).then(response => {
        self.uploadTalkifyAudio(response.data);
      });
    },
    uploadTalkifyAudio(blob) {
      var self = this;
      var data = new FormData();
      
      data.append('audio', blob, `dialogtask_${self.formData.id}.mp3`);
      var onSuccess = response => {
        self.formData.audioUrl = response.data.url;
        self.talkifyAudioCreated = true;
      };
      self.$ajaxPost(self, "tempupload", data, onSuccess);
    },
  },
};
</script>
<style lang="scss" scoped>
  #talkify-audio{display: none;}

  .add-new-data-sidebar {
    /deep/ .vs-sidebar--background

  {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;
    .img-upload

  {
    margin-top: 2rem;
    .con-img-upload

  {
    padding: 0;
  }

  .con-input-upload {
    width: 100%;
    margin: 0;
  }

  }
  }
  }

  #remove-option-button {
    position: absolute;
    top: 5px;
    right: 5px;
  }

  .scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
  }
</style>
